export const calWidgetConstant = {
    GET_MIXRS_BTWN_DAYS_REQUEST: 'CALWIDGET/GET_MIXRS_BTWN_DAYS_REQUEST',
    GET_MIXRS_BTWN_DAYS_SUCCESS: 'CALWIDGET/GET_MIXRS_BTWN_DAYS_SUCCESS',
    GET_MIXRS_BTWN_DAYS_FAILURE: 'CALWIDGET/GET_MIXRS_BTWN_DAYS_FAILURE',

    SET_INITIAL_STATE: 'CALWIDGET/SET_INITIAL_STATE'

}